export default {
  errors: {},
}
